/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/button-has-type */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';

import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import WantToLearnMore from '../../Components/WantToLearnMore';
import NavBarMobileProctoring from '../../Components/NavBarMobileProctoring';

import NavBarVerticalProctoring from '../../Components/NavBarVerticalProctoring';

class Proctoring extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">Edvice</title>
          <meta key="og:title" property="og:title" content="Edvice" />
          <meta key="description" name="description" content="Edvice" />
          <meta key="og:description" property="og:description" content="Edvice" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./1.png')}
            column="col-xs-10 col-xs-offset-0 col-sm-5 col-sm-offset-2"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Linguaskill At-Home</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobileProctoring />
              <NavBarVerticalProctoring />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="exam-format-content">
                <div className="section__one">
                  <p>
                    Linguaskill is a modular online test which assesses all four language skills:
                    reading, listening, writing and speaking.
                  </p>
                  <p>
                    Linguaskill is available as two options, General and Business. This gives you
                    the ability to choose the sort of language that will be tested, based on your
                    objectives.
                  </p>
                  <h2>Linguaskill General</h2>
                  <p>
                    Linguaskill General tests language used in daily life, making it ideal for
                    university admission or exit, and recruitment for roles in a
                    non-business-specific environment. For example, where the employee needs strong
                    English skills to perform their role effectively, but will not need specialist
                    business terminology.
                  </p>
                  <p>
                    This makes the test suitable for a broad spectrum of organisations. Test topics
                    include studying and working, making future plans, travel and technology.
                  </p>
                  <h2>Linguaskill Business</h2>
                  <p>
                    Linguaskill Business tests English used in a business and corporate setting, and
                    is most suitable for recruitment in organisations where employees are expected
                    to be familiar with the language of business.
                  </p>
                  <p>
                    It is suitable for large or small organisations, which may be operating on an
                    international level. Test topics include the buying and selling of products or
                    services, the office, business travel and human resources.
                  </p>
                  <h3>Test Durations</h3>
                  <table className="table__style">
                    <thead>
                      <tr>
                        <th>Linguaskill Tests</th>
                        <th>Test Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Reading and Listening test</td>
                        <td>60-85 minutes</td>
                      </tr>
                      <tr>
                        <td>Writing test</td>
                        <td>45 minutes (2 parts)</td>
                      </tr>
                      <tr>
                        <td>Speaking test</td>
                        <td>15 minutes (5 parts)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <WantToLearnMore />
        <Footer />
      </React.Fragment>
    );
  }
}
export default Proctoring;
